<script setup lang="ts">
import MainNavigation from "./MainNavigation.vue";

// `isExpanded` is driven by BaseView: full (200px, labels) on top-level routes, collapsed to an
// icon rail (56px, labels faded) whenever a sub-navigation is active. Defaults to expanded.
//
// `isVisible` is the third state: a route that carries its own navigation gets a 0px column here
// (navigationLayout's OWN_NAVIGATION_ROUTE_NAMES — the LCA report). Mirrors ProjectSubSidebar, and for
// the same two reasons: BaseView's grid declares one track per column, so the element has to stay in the
// flow, and a hidden-but-mounted navigation must not keep its links in the tab order.
withDefaults(
  defineProps<{
    lCAdaIsShown: boolean;
    isExpanded?: boolean;
    isVisible?: boolean;
    ariaLabel?: string;
  }>(),
  {
    isExpanded: true,
    isVisible: true,
    ariaLabel: "Main navigation",
  }
);

const emit = defineEmits<{
  toggleLCAda: [shown: boolean];
}>();

const navRegionId = "main-sidebar-nav";
</script>

<template>
  <aside
    :aria-label="ariaLabel"
    :aria-hidden="!isVisible"
    :inert="!isVisible"
    class="flex h-full flex-col overflow-hidden bg-slate-50 shadow-[inset_-1px_0_0_0_var(--color-slate-200)] will-change-[width] contain-[layout_style]">
    <nav
      :id="navRegionId"
      class="flex-1 overflow-x-hidden overflow-y-auto">
      <MainNavigation
        v-if="isVisible"
        :is-expanded="isExpanded"
        :l-c-ada-is-shown="lCAdaIsShown"
        @toggle-l-c-ada="(shown) => emit('toggleLCAda', shown)" />
    </nav>
  </aside>
</template>
